import { createAction } from '@ngrx/store';

export const paymentPopupRejection = createAction('[Payment Popup] Payment Popup Rejection');

export const clearPaymentPopupStore = createAction(
    '[Clear Payment Popup] Clear Payment Popup Store'
);

export const logout = createAction('[Header] Logout');
